import clsx from 'clsx'
import { ColorSwatch, IconImage } from './FilterCustomisations'

export function FilterInputPalette({ values, onFilter, name }) {
  return (
    <div className="grid grid-cols-4 items-stretch gap-2">
      {values.map((item) => {
        return (
          <label
            key={item.value}
            for={item.value}
            className={clsx(
              'flex flex-col items-center gap-1 h-auto min-h-[71px] px-1 py-2 text-center rounded-sm border cursor-pointer transition-colors',
              item.checked ? 'border-primary-black' : 'border-neutrals-light-grey',
              item.disabled && 'cursor-not-allowed opacity-50'
            )}
          >
            <input
              id={item.value}
              type="checkbox"
              name={name}
              checked={item.checked}
              disabled={item.disabled}
              onClick={() => onFilter(item.value)}
              className="sr-only"
            />
            {item.icon ? (
              <IconImage iconObject={item.icon} width={28} />
            ) : item.color ? (
              <ColorSwatch color={item.color} className="size-7" />
            ) : null}
            <div className="grow flex flex-col items-center justify-center text-center">
              <span className="paragraph-sm">{item.label}</span>
            </div>
          </label>
        )
      })}
    </div>
  )
}
